import React, {FC} from 'react';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grow from '@material-ui/core/Grow';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import {withStyles} from '@material-ui/core';
import ErrorIcon from '@material-ui/icons/Error';
import {withLocalization} from 'epic-localization/src/context/LocalizationContext';
import {Alert} from '@material-ui/lab';
import {getDirectionStyles} from '../../../utils/ThemeUtils';

export const CircularProgressWrapper = withStyles(theme => ({
    root: {
        margin: getDirectionStyles(theme.direction)(
            theme.spacing(0, 4, 0, 0),
            theme.spacing(0, 0, 0, 4)
        )
    }
}))(Box);

const CODES = {
    loading: 'epic.affiliate.fortnite_games.widget_pdf_download.loading',
    error: 'epic.affiliate.fortnite_games.widget_download.error',
    retry: 'epic.affiliate.fortnite_games.widget_download.retry'
};

export enum Statuses {
    idle,
    loading,
    error
}

export interface StatusPopoverProps {
    status: Statuses;
    onRetry: () => void;
    onClose?: () => void;
    getMessage: (code: string) => string;
    loadingMessageCode?: string;
}

const StatusSnackbar: FC<StatusPopoverProps> = ({
    status,
    onRetry,
    onClose,
    getMessage,
    loadingMessageCode = CODES.loading
}: StatusPopoverProps) => (
    <Snackbar
        key="export-snackbar"
        open={status !== Statuses.idle}
        onClose={onClose}
        TransitionComponent={Grow}
        autoHideDuration={status === Statuses.error ? 4000 : undefined}>
        <div>
            {status === Statuses.loading && (
                <SnackbarContent
                    key="loading-snack-content"
                    message={
                        <>
                            <CircularProgressWrapper clone>
                                <CircularProgress size={20} color="inherit" />
                            </CircularProgressWrapper>
                            {getMessage(loadingMessageCode)}
                        </>
                    }
                />
            )}
            {status === Statuses.error && (
                <Alert
                    key="error-snack-content"
                    severity="error"
                    icon={<ErrorIcon />}
                    action={
                        <Button variant="text" onClick={onRetry}>
                            {getMessage(CODES.retry)}
                        </Button>
                    }>
                    {getMessage(CODES.error)}
                </Alert>
            )}
        </div>
    </Snackbar>
);

export default withLocalization(StatusSnackbar);
